module.exports = __webpack_public_path__ + "../resources/images/coffee-02-eceaed8175e5ceaff61a4dd20ad03bcf.jpg";